module.exports = __webpack_public_path__ + "static/media/Degtyar.a2738183.jpeg";